import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './ContentCard-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { getCdnImage } from '../../../utils/ImageManager';
import { getPrimaryRating } from '../../../services/bazaarvoice-api';
import Typography from '../../Generic/Typography';
import { Button } from '../../Generic/Button';
import Rating from '../../Generic/Rating';
import urlProvider from '../../../utils/url-manager/urlProvider';
import dynamic from 'next/dynamic';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';
import ALP_Constants from '../../Brand/ArticleListingPage/constants'

// Dynamically import BuyNowLiteComponent with SSR disabled
const BuyNowLiteComponent = dynamic(() => import('../../Generic/BuyNowLite'), { 
  ssr: false, 
  loading: () => null 
});

class ContentCard extends Component {
  state = {
    ratingData: null,
  };
  componentDidMount() {
    const { data, pageContext } = this.props;
    const productIdList = [];
    let productDetail = data;
    if (
      productDetail &&
      productDetail.referencePageCollection &&
      productDetail.referencePageCollection.items.length > 0 &&
      productDetail.referencePageCollection.items[0].ratingAndReviewId
    ) {
      productIdList.push(
        productDetail &&
          productDetail.referencePageCollection.items[0].ratingAndReviewId
      );
      getPrimaryRating(productIdList, pageContext.locale)
        .then(res => {
          if (res.data.Results.length > 0) {
            this.setState({
              ratingData: res.data.Results[0],
            });
          }
        })
        .catch(err => {
          throw new Error(err);
        });
    }
  }

  averageOverallRatingFormat = avgOverAllRating => {
    if (avgOverAllRating % 1 === 0) {
      return avgOverAllRating;
    } else {
      return avgOverAllRating.toFixed(2);
    }
  };
  render() {
    const { data, pageContext } = this.props;
    const { ratingData } = this.state;
    let contentType = data.styles && data.styles.trim();
    if (styles[contentType] === undefined) {
      contentType = i18nMessages.contentpagetextright;
    }
    const widthClass = getWidth(data.componentWidth);
    const productSlug =
      data &&
      data.referencePageCollection &&
      data.referencePageCollection.items.length > 0 &&
      `${data.referencePageCollection.items[0].parentPage &&
        data.referencePageCollection.items[0].parentPage.slug}/${
        data.referencePageCollection.items[0].slug
      }`;

    const constants = require(`../../../constants/messages/${pageContext.locale}`);
    const link = urlProvider(
      constants.productPage,
      pageContext.locale,
      productSlug
    );
    const linkData = data.linkButtonCollection;
    const linkURL = urlProvider(
      i18nMessages.contentPage,
      pageContext.locale,
      linkData.items.length > 0 && linkData.items[0].link
    );
    return (
      <div className={classNames(styles[contentType].mainWrapper, widthClass)}>
        <div className={classNames(styles[contentType].innerWrapper)}>
          <div className={classNames(styles[contentType].imageWrapper)}>
            {data &&
              data.primaryImageCollection &&
              data.primaryImageCollection.items.length > 0 &&
              data.primaryImageCollection.items.map((imgData, index) => {
                return (
                  <a href={imgData.link}>
                  <img
                    key={index}
                    aria-label="imglink"
                    src={getCdnImage(imgData.image && imgData.image.url, {w:450})}
                    alt={imgData.altText}
                    className={classNames(
                      styles[contentType].imageStyles,
                      getWidth(imgData.componentWidth)
                    )}
                  />
                </a>
                );
              })}
          </div>
          <div className={classNames(styles[contentType].textContent)}>
            <>
              {data &&
                data.referencePageCollection &&
                data.referencePageCollection.items.length > 0 && (
                  <div
                    className={classNames(styles[contentType].ratingWrapper)}
                  >
                    <Rating
                      rating={
                        ratingData &&
                        ratingData.ReviewStatistics &&
                        ratingData.ReviewStatistics.AverageOverallRating != null
                          ? ratingData.ReviewStatistics.AverageOverallRating
                          : 0
                      }
                    />
                    <Typography
                      component="span"
                      className={classNames(
                        styles[contentType].ratingTextCount
                      )}
                    >
                      {`${
                        ratingData &&
                        ratingData.ReviewStatistics &&
                        ratingData.ReviewStatistics.AverageOverallRating != null
                          ? this.averageOverallRatingFormat(
                              ratingData.ReviewStatistics.AverageOverallRating
                            )
                          : 0
                      }/${
                        ratingData && ratingData.ReviewStatistics
                          ? ratingData.ReviewStatistics.OverallRatingRange
                          : 5
                      } (${
                        ratingData && ratingData.ReviewStatistics
                          ? ratingData.TotalReviewCount
                          : 0
                      })`}
                    </Typography>
                  </div>
                )}
            </>
            <Typography
              key={data.sys.id}
              className={classNames(styles[contentType].headingStyle)}
              component="div"
              dangerouslySetInnerHTML={
                data.title && {
                  __html:DOMPurify.sanitize( data.title),
                }
              }
            />
            <Typography
              key={data.sys.id}
              className={classNames(styles[contentType].subText)}
              component="div"
              dangerouslySetInnerHTML={
                data.text && {
                  __html:DOMPurify.sanitize( data.text),
                }
              }
            />
            <div className={styles.contentCollectionBuyNow}>
              
              {link && link.path ? (
                <Button
                  to={link.path}
                  className={classNames(styles[contentType].knowMoreButton,'know_more_mais')}
                >
                  {constants.knowMore}
                </Button>
              ) : null}
              {data &&
                data.referencePageCollection &&
                data.referencePageCollection.items.length > 0 &&
                data.referencePageCollection.items[0].gtin && (
                  <BuyNowLiteComponent
                    className={classNames(
                      styles[contentType].knowMoreButton,
                      'event_buy_now know_more_comprar'
                    )}
                    gtinId={
                      data &&
                      data.referencePageCollection.items &&
                      data.referencePageCollection.items[0].gtin
                    }
                    linkText={constants.buyNow}
                    variant={
                      data &&
                      data.referencePageCollection.items &&
                      data.referencePageCollection.items[0]
                        .variantsCollection &&
                      data.referencePageCollection.items[0].variantsCollection
                        .items
                    }
                    productShortName={
                      data &&
                      data.referencePageCollection.items &&
                      data.referencePageCollection.items[0].productName
                    }
                  />
                )}
            </div>
            {linkData && linkData.items.length > 0 ? (
              <Button
                to={linkURL.path}
                className={classNames(styles[contentType].discoverMore)}
                key={linkData.items[0].sys.id}
                title={linkData.items[0].tooltip}
                target={linkData.items[0].target}
                aria-label={ALP_Constants.DiscoverMoreButton}
              >
                {linkData.items[0].linkText}
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

ContentCard.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
  pageContext: PropTypes.oneOfType([PropTypes.object]),
};

ContentCard.defaultProps = {
  data: null,
  pageContext: null,
};
export default ContentCard;
